interface Param {
  param: string;
  value: string;
}

export function addParamsToUrl(url: string, params: Param[]): string {
  try {
    const urlWithParams = new URL(url);

    params.forEach(({ param, value }) => {
      urlWithParams.searchParams.append(param, value);
    });

    return urlWithParams.toString();
  } catch (err) {
    console.error(err);

    return url;
  }
}
